<template>
    <component :is="tag">
        <slot
            :step="step"
            :brief="brief"
            :contact="contact"
            :network-id="networkId"
            :go-next-step="goNextStep"
            :go-previous-step="goPreviousStep"
            :patch-step="patchStep"
            :is-loading="isLoading"
            :is-completing-brief="isCompletingBrief"
            :is-patching-brief="isPatchingBrief"
            :errors="errors"
            :error-message="errorMessage"
            :connection-source-request-data="connectionSourceRequestData"
            :connection-source="connectionSource"
            :handle-complete-connection="handleCompleteConnection"
            :handle-failed-connection="handleFailedConnection"
            :handle-connect-instagram="handleConnectInstagram"
            :force-reload-contact="forceReloadContact"
            :instagram-graph-required="instagramGraphRequired"
        />
    </component>
</template>

<script>
    import { NAME_NETWORKS } from '../../../constants/activation-brief-steps';
    import ContactsMixin from '../mixins/ContactsMixin';
    import BaseActivationBriefStepMixin from '../mixins/BaseActivationBriefStepMixin';
    import ActivationBriefNetworkConnectionSourceMixin from '../mixins/ActivationBriefNetworkConnectionSourceMixin';
    import useNetworks from '../../../../src/composables/use-networks';

    export default {
        name: 'ActivationBriefNetworksProvider',
        mixins: [BaseActivationBriefStepMixin, ContactsMixin, ActivationBriefNetworkConnectionSourceMixin],
        computed: {
            step() {
                return this.steps[NAME_NETWORKS];
            },
            networkId() {
                return +this.$route.query.networkId || +this.$route.params.networkId;
            },
            instagramGraphRequired() {
                return useNetworks().isInstagramGraphRequiredForActivationBrief(this.brief);
            }
        },
        methods: {
            forceReloadContact() {
                this.loadContact(true).catch((error) => this.handleHttpError(error));
            }
        },
        created() {
            this.isLoading = true;

            this.loadContact()
                .then(() => {
                    return Promise.all([this.loadActivationBrief()]);
                })
                .then(() => {
                    this.initStep(this.step);
                })
                .catch((error) => this.handleHttpError(error))
                .then(() => {
                    this.isLoading = false;
                });
        }
    };
</script>

<style scoped></style>
